module.exports = " <div class=load _v-60322062=\"\"> <p class=shadow _v-60322062=\"\"></p> <div class=loadTxt _v-60322062=\"\"> <div class=loadLeft _v-60322062=\"\"> <span class=loadCircle _v-60322062=\"\"></span> <span class=loadImg _v-60322062=\"\"></span> </div> <span class=loadText _v-60322062=\"\">{{loadingtext}}</span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-60322062!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/Loading.vue
// module id = 154
// module chunks = 0